var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.963 2.38457L9.48087 18.1279L1.33957 11.9421L1.33962 11.9421L1.33372 11.9378C0.738545 11.508 0.625675 10.67 1.07204 10.052C1.50125 9.45772 2.3373 9.3443 2.95508 9.78833L8.59029 14.0662L8.84435 14.259L9.02129 13.9936L17.7461 0.906442C18.1556 0.292226 18.9956 0.105332 19.5843 0.530535L19.5842 0.530706L19.5936 0.536946C20.2078 0.946423 20.3947 1.78645 19.9695 2.37519L19.9693 2.37506L19.963 2.38457Z",
    fill: "white",
    stroke: "#146C94",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckwhite);
export default __webpack_public_path__ + "static/media/checkwhite.8dd9eabc7b12d7ff8eae1021a7eb180d.svg";
export { ForwardRef as ReactComponent };